export const PRODUCTS_TAB = 'products';
export const SERVICES_TAB = 'services';
export const DISCOUNTS_TAB = 'discounts';
export const MEMBERSHIPS_TAB = 'memberships';

export const SET_ACTIVE_BARBER = 'sale/SET_ACTIVE_BARBER';
export const SET_PRODUCT_CATEGORY_ID = 'sale/SET_PRODUCT_CATEGORY_ID';
export const SET_PRODUCT_BRAND_ID = 'sale/SET_PRODUCT_BRAND_ID';
export const CHARGE = 'sale/CHARGE';
export const CHECKOUT = 'sale/CHECKOUT';
export const SET_PRODUCT_SEARCH = 'sale/SET_PRODUCT_SEARCH';
export const SET_SERVICE_SEARCH = 'sale/SET_SERVICE_SEARCH';
export const SELECT_TAB = 'sale/SELECT_TAB';
export const RESET_TAB = 'sale/RESET_TAB';
